import { addDefaultIfEmpty, insertAfterIndex, removeAtIndex, sum, updateAtIndex } from "../../helpers/array"
import { uniqueId } from "../../helpers/uniqueId"

export type Material = {
  id: string
  description: string
  annualCost: number
}

export const emptyMaterial = (): Material => ({id: uniqueId(), description: '', annualCost: 0 })

export const createDefaultMaterials = (): Material[] => [
  emptyMaterial()
]

export const sumMaterials = (materials: Material[]): number =>
  sum(materials, x => x.annualCost)


export const updateAnnualCost = (materials: Material[], index: number, annualCost: number): Material[] =>
  updateAtIndex(materials, index, x => ({ ...x, annualCost }))

export const updateDescription = (materials: Material[], index: number, description: string): Material[] =>
  updateAtIndex(materials, index, x => ({ ...x, description }))

export const add = (materials: Material[], index: number) =>
  insertAfterIndex(materials, index, emptyMaterial())

export const remove = (materials: Material[], index: number) =>
  addDefaultIfEmpty(removeAtIndex(materials, index), emptyMaterial())

export const enforceInvariants = (materials:Material[] | undefined): Material[] => {
  if (materials && materials.length > 0) {
    return materials;
  }
  return createDefaultMaterials()
}